import React, { useState } from 'react';
import emailjs from 'emailjs-com'; // Import EmailJS library
import { getStorage, ref, uploadBytes } from 'firebase/storage'; // Firebase Storage
import "./registration.css";
import { getDownloadURL } from 'firebase/storage';

function ShortTermCourseRegistration() {
  const [formData, setFormData] = useState({
    email: '',
    name: '',
    permanentAddress: '',
    contactNo: '',
    correspondentAddress: '',
    nicPassportNo: '',
    academicQualification: 'Ordinary Level',
    selectedCourse: 'Fellowship in Clinical Optometry',
    courseType: 'Part time',
    // termConditionFile: null,
    paymentSlipFile: null,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: files[0],
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();


if (!formData.paymentSlipFile) {
  alert("Please upload a payment slip!");
  return;
}



    try {
      // Initialize Firebase Storage
      const storage = getStorage();

      // Upload the terms and conditions file to Firebase Storage
      // const termsRef = ref(storage, `shortTermCourse/${formData.termConditionFile.name}`);
      // await uploadBytes(termsRef, formData.termConditionFile);
      // const termConditionUrl = await getDownloadURL(termsRef);

      // Upload the payment slip to Firebase Storage
      const paymentRef = ref(storage, `shortTermCourse/${formData.paymentSlipFile.name}`);
      await uploadBytes(paymentRef, formData.paymentSlipFile);
      const paymentSlipUrl = await getDownloadURL(paymentRef);

      // Prepare the data for EmailJS
      const emailData = {
        from_email: formData.email,
        from_name: formData.name,
        permanent_address: formData.permanentAddress,
        contact_no: formData.contactNo,
        correspondent_address: formData.correspondentAddress,
        nic_passport_no: formData.nicPassportNo,
        academic_qualification: formData.academicQualification,
        selected_course: formData.selectedCourse,
        course_type: formData.courseType,
        paymentSlipUrl, // Optional: Include this in the email if needed
        // termConditionUrl
      };

      // Send email via EmailJS
      await emailjs.send(
       
        'service_u7ymc2g', // Replace with your EmailJS service ID
        'template_0wsm54o', // Replace with your EmailJS template ID
        emailData,
        'hZsMgi7_QDOxxUnv0' // Replace with your EmailJS public key
      );

      alert('Registration email sent successfully!');
    } catch (error) {
      console.error('Error submitting form:', error);
      alert('There was an error processing your registration. Please try again.');
    }
  };

  return (
    <div className="course-registration">
      <h2>Eye Care Institute - Fellowship Course Registration</h2>
      {/* <form onSubmit={handleSubmit}>
        <div>
          <label>Email:</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </div>
        <div>
          <label>Name:</label>
          <input
            type="text"
            name="name"
            placeholder="Enter your name"
            value={formData.name}
            onChange={handleChange}
            required
          />
        </div>
        <div>
          <label>Permanent Address:</label>
          <input
            type="text"
            name="permanentAddress"
            placeholder="Enter your permanent address"
            value={formData.permanentAddress}
            onChange={handleChange}
            required
          />
        </div>
        <div>
          <label>Contact No:</label>
          <input
            type="text"
            name="contactNo"
            placeholder="Enter your Contact number"
            value={formData.contactNo}
            onChange={handleChange}
            required
            maxLength="10"
            pattern="\d{10}"
            title="Please enter exactly 10 digits"
          />
        </div>
        <div>
          <label>Correspondent Address:</label>
          <input
            type="text"
            name="correspondentAddress"
            placeholder="Enter your correspondent address"
            value={formData.correspondentAddress}
            onChange={handleChange}
            required
          />
        </div>
        <div>
          <label>NIC / Passport No:</label>
          <input
            type="text"
            name="nicPassportNo"
            placeholder="Enter your NIC or passport number"
            value={formData.nicPassportNo}
            onChange={handleChange}
            required
          />
        </div>
        <div>
          <label>Academic Qualification:</label>
          <select
            name="academicQualification"
            value={formData.academicQualification}
            onChange={handleChange}
            required
          >
            <option value="Ordinary Level">Ordinary Level</option>
            <option value="Advanced Level">Advanced Level</option>
          </select>
        </div>
        <div>
          <label>Select Fellowship Course:</label>
          <select
            name="selectedCourse"
            value={formData.selectedCourse}
            onChange={handleChange}
            required
          >
            <option value="Fellowship in Clinical Optometry">Fellowship in Clinical Optometry</option>
            <option value="Fellowship in Low Vision Rehabilitation">Fellowship in Low Vision Rehabilitation</option>
            <option value="Fellowship in Pediatric Optometry">Fellowship in Pediatric Optometry</option>
            <option value="Fellowship in Spectacle Dispensing">Fellowship in Spectacle Dispensing</option>
            <option value="Fellowship in Ocular motility and Binocular Vision">
              Fellowship in Ocular motility and Binocular Vision
            </option>
            <option value="Fellowship in Contact Lens Dispensing">Fellowship in Contact Lens Dispensing</option>
          </select>
        </div>
        <div>
          <label>Course Type:</label>
          <select
            name="courseType"
            value={formData.courseType}
            onChange={handleChange}
            required
            disabled
          >
            <option value="Part time">Part time</option>
          </select>
        </div>

        

<div className="form-group">
  <label htmlFor="payment-slip">Upload Payment Slip (PDF, JPG, PNG - Max 5MB)</label>

  <div
    style={{
      border: `2px dashed ${formData.paymentSlipFile ? '#4CAF50' : '#ccc'}`,
      padding: '20px',
      textAlign: 'center',
      borderRadius: '5px',
      margin: '10px 0',
      backgroundColor: formData.paymentSlipFile ? '#f0fff0' : '#f9f9f9',
      cursor: 'pointer',
    }}
  >
    {/* 
    <input
      type="file"
      id="payment-slip"
      name="paymentSlipFile"          // matches state
      accept=".jpg,.jpeg,.png,.pdf"
      onChange={handleFileChange}     // updates state
      style={{ display: 'none' }}
    />

    {/* Styled visible button 
    <label
      htmlFor="payment-slip"
      style={{
        cursor: 'pointer',
        display: 'inline-block',
        backgroundColor: '#007bff',
        color: 'white',
        padding: '10px 20px',
        borderRadius: '5px',
        fontWeight: 'bold',
      }}
    >
      {formData.paymentSlipFile ? (
        <span>✅ {formData.paymentSlipFile.name} (Click to change)</span>
      ) : (
        <span>📤 Upload File</span>
      )}
    </label>
  </div>
</div>






        

        <div>
          <button type="submit" className="reg-submit-button">Submit</button>
        </div>
      </form> */}





<form onSubmit={handleSubmit} className="registration-form">
  <div className="form-group">
    <label>Email:</label>
    <input
      type="email"
      name="email"
      value={formData.email}
      onChange={handleChange}
      required
    />
  </div>

  <div className="form-group">
    <label>Name:</label>
    <input
      type="text"
      name="name"
      placeholder="Enter your name"
      value={formData.name}
      onChange={handleChange}
      required
    />
  </div>

  <div className="form-group">
    <label>Permanent Address:</label>
    <input
      type="text"
      name="permanentAddress"
      placeholder="Enter your permanent address"
      value={formData.permanentAddress}
      onChange={handleChange}
      required
    />
  </div>

  <div className="form-group">
    <label>Contact No:</label>
    <input
      type="text"
      name="contactNo"
      placeholder="Enter your Contact number"
      value={formData.contactNo}
      onChange={handleChange}
      required
      maxLength="10"
      pattern="\d{10}"
      title="Please enter exactly 10 digits"
    />
  </div>

  <div className="form-group">
    <label>Correspondent Address:</label>
    <input
      type="text"
      name="correspondentAddress"
      placeholder="Enter your correspondent address"
      value={formData.correspondentAddress}
      onChange={handleChange}
      required
    />
  </div>

  <div className="form-group">
    <label>NIC / Passport No:</label>
    <input
      type="text"
      name="nicPassportNo"
      placeholder="Enter your NIC or passport number"
      value={formData.nicPassportNo}
      onChange={handleChange}
      required
    />
  </div>

  <div className="form-group">
    <label>Academic Qualification:</label>
    <select
      name="academicQualification"
      value={formData.academicQualification}
      onChange={handleChange}
      required
    >
      <option value="Ordinary Level">Ordinary Level</option>
      <option value="Advanced Level">Advanced Level</option>
    </select>
  </div>

  <div className="form-group">
    <label>Select Fellowship Course:</label>
    <select
      name="selectedCourse"
      value={formData.selectedCourse}
      onChange={handleChange}
      required
    >
      <option value="Fellowship in Clinical Optometry">Fellowship in Clinical Optometry</option>
      <option value="Fellowship in Low Vision Rehabilitation">Fellowship in Low Vision Rehabilitation</option>
      <option value="Fellowship in Pediatric Optometry">Fellowship in Pediatric Optometry</option>
      <option value="Fellowship in Spectacle Dispensing">Fellowship in Spectacle Dispensing</option>
      <option value="Fellowship in Ocular motility and Binocular Vision">
        Fellowship in Ocular motility and Binocular Vision
      </option>
      <option value="Fellowship in Contact Lens Dispensing">Fellowship in Contact Lens Dispensing</option>
    </select>
  </div>

  <div className="form-group">
    <label>Course Type:</label>
    <select
      name="courseType"
      value={formData.courseType}
      onChange={handleChange}
      required
      disabled
    >
      <option value="Part time">Part time</option>
    </select>
  </div>

  <div className="form-group upload-field">
    <label htmlFor="payment-slip">Upload Payment Slip (PDF, JPG, PNG - Max 5MB)</label>

    <div
      style={{
        border: `2px dashed ${formData.paymentSlipFile ? '#4CAF50' : '#ccc'}`,
        padding: '20px',
        textAlign: 'center',
        borderRadius: '5px',
        margin: '10px 0',
        backgroundColor: formData.paymentSlipFile ? '#f0fff0' : '#f9f9f9',
        cursor: 'pointer',
      }}
    >
      <input
        type="file"
        id="payment-slip"
        name="paymentSlipFile"
        accept=".jpg,.jpeg,.png,.pdf"
        onChange={handleFileChange}
        style={{ display: 'none' }}
      />
      <label
        htmlFor="payment-slip"
        className="upload-label"
      >
        {formData.paymentSlipFile ? (
          <span>✅ {formData.paymentSlipFile.name} (Click to change)</span>
        ) : (
          <span>📤 Upload File</span>
        )}
      </label>
    </div>
  </div>

  <div className="form-group full-width">
    <button type="submit" className="reg-submit-button">Submit</button>
  </div>
</form>














      <div className="bank-details-container">
        <h2 className="bank-details-heading">Bank Details</h2>
        <div className="bank-detail-item">
          <strong>Account No</strong> <span> : 055010165128</span>
        </div>
        <div className="bank-detail-item">
          <strong>Account Name</strong> <span> : EYE CARE INSTITUTE (PVT) LTD</span>
        </div>
        <div className="bank-detail-item">
          <strong>Bank</strong> <span> : Hatton National Bank</span>
        </div>
        <div className="bank-detail-item">
          <strong>Branch</strong> <span> : Borella</span>
        </div>
      </div>



    </div>
  );
}

export default ShortTermCourseRegistration;
